import { render, staticRenderFns } from "./SplitButton.vue?vue&type=template&id=34b811f8"
import script from "./SplitButton.vue?vue&type=script&lang=js"
export * from "./SplitButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports